export default {
  plaidItems: null,
  plaidStatus: null
}
